import firebase from 'firebase/app';
import 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyBvbAXnat6wk8a4zvCii8aGRiM4moo9oVw',
  authDomain: 'kiper-assembleia.firebaseapp.com',
  databaseURL: 'https://kiper-assembleia.firebaseio.com',
  projectId: 'kiper-assembleia',
  storageBucket: 'kiper-assembleia.appspot.com',
  messagingSenderId: '1046577655913',
  appId: '1:1046577655913:web:076d3d9894193b2ef772f8',
  measurementId: 'G-QG0RFX1E27',
};

firebase.initializeApp(firebaseConfig);

export default firebase;

export const updateCurrentUser = ({ email }) => Promise.all([firebase.auth().currentUser.updateEmail(email)]);

export const isLoggedIn = async (RETRY_TIMES = 5) =>
  new Promise(resolve => {
    let times = 1;
    const DELAY = 300;
    const tryToGetUser = async () => {
      if (!firebase.auth().currentUser && times <= RETRY_TIMES) {
        times += 1;
        return setTimeout(tryToGetUser, times * DELAY);
      }

      if (!firebase.auth().currentUser) {
        return resolve(false);
      }

      await firebase.auth().currentUser.reload();
      // await firebase.auth().currentUser.ref
      if (!firebase.auth().currentUser.email || !firebase.auth().currentUser.phoneNumber) {
        return resolve(false);
      }
      return resolve(true);
    };

    return tryToGetUser();
  });

export const providers = {
  facebook: () => {
    const provider = new firebase.auth.FacebookAuthProvider();
    provider.addScope('email');
    return provider;
  },
  google: () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    // provider.addScope('email');
    return provider;
  },
};

export const linkAccount = async authorizationData => {
  if (!authorizationData || !authorizationData.authorization) return;

  const { authorization } = authorizationData;
  let credential;
  switch (authorization.credential.providerId) {
    case 'google.com':
      credential = firebase.auth.GoogleAuthProvider.credential(authorization.credential.idToken);
      break;
    case 'facebook.com':
      credential = firebase.auth.FacebookAuthProvider.credential(authorization.credential.accessToken);
      break;
    default:
  }
  await firebase.auth().currentUser.linkWithCredential(credential);
};
